'use client'

import { useEffect, useState } from 'react'

const VISIT_KEY = 'ff_visit_count'
const DISMISSED_KEY = 'ff_pwa_dismissed'

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Already running as installed PWA — nothing to show
    if (window.matchMedia('(display-mode: standalone)').matches) return
    // User already responded to this prompt
    if (localStorage.getItem(DISMISSED_KEY)) return

    // Track visits (increment once per page load)
    const count = parseInt(localStorage.getItem(VISIT_KEY) || '0', 10) + 1
    localStorage.setItem(VISIT_KEY, String(count))

    const handler = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      if (count >= 2) setVisible(true)
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  async function install() {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    localStorage.setItem(DISMISSED_KEY, outcome === 'accepted' ? 'installed' : 'dismissed')
    setVisible(false)
    setDeferredPrompt(null)
  }

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, 'dismissed')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-gray-900 border-t border-blue-800 px-6 py-4">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center gap-4 justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl" aria-hidden="true">✈️</span>
          <div>
            <p className="text-white text-sm font-semibold">Install FairFares</p>
            <p className="text-gray-400 text-xs">Get cheap deals on your home screen — no app store needed.</p>
          </div>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={dismiss}
            className="text-sm text-gray-400 hover:text-white transition-colors px-3 py-1.5"
          >
            Not now
          </button>
          <button
            onClick={install}
            className="text-sm bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg px-4 py-1.5 transition-colors"
          >
            Install
          </button>
        </div>
      </div>
    </div>
  )
}
